export const GET_ALLERGENS = "ADD_ALLERGENS";
